export const version = '@PUBLIC_VERSION@';
